import * as React from 'react';
import { Component } from 'react';
import { RouteComponentProps } from 'react-router';
import { IUserInfo } from '../../models/IUserInfo';
import './NavMenu.css';
import { SimpleSelectComponent } from '../../controls/SimpleSelect';
import { IDropDownItem } from "../../models/IDropdownItem";
import { IdentityService } from '../../services/IdentityService';
import { ShowStatusBar } from '../Layout/GlobalStatusBar';
import { DEFAULT_STATUS_TIMEOUT } from '../../constants/SystemConsts';
import { connect } from 'react-redux';

function MapState(state) {
    return {
        UserInfo: state.Profile
    }
}
interface IProps extends RouteComponentProps<any> {
    UserInfo: IUserInfo | null;
    HideMenu: boolean;
}

class NavMenu extends Component<IProps, any>  {
    constructor(props) {
        super(props);
    }

    public render() {
        const dropdownItems: IDropDownItem[] = [
            {
                Value: "Ustawienia",
                Icon: "settings",
                OnClick: this.GoToSettings
            },
            {
                Value: "Wyloguj się",
                Icon: "logout",
                OnClick: this.Logout
            }
        ]
        const { UserInfo, HideMenu } = this.props;
        return (
            <nav className="nav">
                <div
                    onClick={this.GoToAppChoose}
                    className="nav-logo" />
                <div className="nav-buttons">
                    <div className="helper-buttons">
                        <div onClick={this.toggleContrast} className="helper-buttons__button helper-buttons__button--eye" />
                        <p onClick={this.makeFontSmaller} className="helper-buttons__button helper-buttons__button--small">A</p>
                        <p onClick={this.makeFontBigger} className="helper-buttons__button helper-buttons__button--big">A</p>
                    </div>

                    {!HideMenu &&
                        <SimpleSelectComponent
                            Title={UserInfo ? UserInfo.userName : ""}
                            Items={dropdownItems}
                        />
                    }
                </div>
            </nav>
        );
    }

    private Logout = () => {
        let service = new IdentityService();
        service.LogOut(this.OnLogoutSuccess, this.OnLogoutError);
    }

    private GoToSettings = () => {
        this.props.history.replace('/app/settings');
    }

    private GoToAppChoose = () => {
        this.props.history.replace('/app/choose');
    }

    private OnLogoutSuccess = (result) => {
        const { UserInfo, history } = this.props;
        if (UserInfo !== null) {
            UserInfo.isAuthenticated = false;
        }
        history.push('/');
    }

    private OnLogoutError = (error) => {
        ShowStatusBar('Error', 'Nie udało się wylogować. Spróbuj ponownie', DEFAULT_STATUS_TIMEOUT);
    }

    private toggleContrast = (evt) => {
        document.documentElement.classList.toggle('contrast');
    }

    private makeFontBigger = (evt) => {
        document.documentElement.classList.add('bigger-font');
    }

    private makeFontSmaller = (evt) => {
        document.documentElement.classList.remove('bigger-font');
    }
}

export default connect(MapState)(NavMenu);



// WEBPACK FOOTER //
// ./src/components/NavMenu/NavMenu.tsx